import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=65e3acdd&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e3acdd')) {
      api.createRecord('65e3acdd', component.options)
    } else {
      api.reload('65e3acdd', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=65e3acdd&", function () {
      api.rerender('65e3acdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DonationModal/Main.vue"
export default component.exports